import { Icon } from '@iconify/react';
import RevealWrap from './RevealWrap';

const BRANDS = [
  { icon: 'solar:shop-bold', name: 'BBQ치킨' },
  { icon: 'solar:cup-hot-bold', name: '스타벅스' },
  { icon: 'solar:pot-bold', name: '새마을식당' },
  { icon: 'solar:chef-hat-bold', name: '교촌치킨' },
  { icon: 'solar:bowl-bold', name: '명륜진사갈비' },
  { icon: 'solar:hamburger-bold', name: '맘스터치' },
  { icon: 'solar:flame-bold', name: '홍콩반점' },
  { icon: 'solar:pizza-bold', name: '피자헛' },
  { icon: 'solar:wine-bold', name: '역전우동' },
  { icon: 'solar:leaf-bold', name: '본죽' },
];

function BrandRow() {
  return (
    <div className="flex items-center gap-14 px-7">
      {BRANDS.map((b) => (
        <div
          key={b.name}
          className="flex items-center gap-2.5 text-neutral-400 opacity-50 hover:opacity-100 hover:text-neutral-700 transition-all duration-500"
        >
          <Icon icon={b.icon} className="text-2xl" />
          <span className="font-semibold text-lg whitespace-nowrap">{b.name}</span>
        </div>
      ))}
    </div>
  );
}

export default function TrustBar() {
  return (
    <section className="py-20 bg-neutral-50 border-y border-neutral-200/60 overflow-hidden">
      <RevealWrap animation="scale" className="max-w-7xl mx-auto px-6 lg:px-8 mb-10">
        <div className="flex items-center justify-center gap-4">
          <div className="h-px flex-1 max-w-[80px] bg-gradient-to-r from-transparent to-neutral-300" />
          <p className="text-center text-neutral-500 text-sm font-medium tracking-wide">
            이미 대형 프랜차이즈들이 도입한 QR 오더, 우리 매장은요?
          </p>
          <div className="h-px flex-1 max-w-[80px] bg-gradient-to-l from-transparent to-neutral-300" />
        </div>
      </RevealWrap>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-neutral-50 to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-neutral-50 to-transparent z-10" />
        <div className="flex animate-marquee hover:[animation-play-state:paused]" style={{ width: 'max-content' }}>
          <BrandRow />
          <BrandRow />
        </div>
      </div>
    </section>
  );
}
